export default class Part {
    static render(width, mods) {
        // const WIDTH = width * SIZE.pxInMm;/
        const HEIGHT = SIZE.baseHeight // TODO  
        let x = 20
        let y = (HEIGHT - 74.6) / 2;

        return `<image href="${PARTS.point}" x="${x}" y="${y}" />`
    }
}
